import React from "react";
import "./Footer.css";

const Footer = () => (
  <div className="footer">
    <p>Built using create-react-app + firebase</p>
  </div>
);
export default Footer;
